import type { AttendanceDayMetrics, AttendanceDayStatus } from '@erp/shared';
import { useTranslation } from 'react-i18next';

import { Badge } from '../../../components/ui/index.js';
import { formatMinutes } from '../../../lib/attendance.js';

type Tone = 'neutral' | 'success' | 'warning' | 'danger' | 'info' | 'brand';

export const STATUS_TONE: Record<AttendanceDayStatus, Tone> = {
  present: 'success',
  absent: 'danger',
  not_yet: 'neutral',
  untracked: 'neutral',
  leave: 'info',
  holiday: 'brand',
  off: 'neutral',
  upcoming: 'neutral',
  unscheduled: 'neutral',
  not_employed: 'neutral',
};

/** A day's status plus the flags a manager scans for: late, still in, never clocked out. */
export function AttendanceStatusBadge({ day }: { day: AttendanceDayMetrics }): JSX.Element {
  const { t } = useTranslation('hr');
  return (
    <span className="inline-flex flex-wrap items-center gap-1">
      <Badge tone={STATUS_TONE[day.status]}>
        {day.status === 'holiday' && day.holidayName ? day.holidayName : t(`attendance.status.${day.status}`)}
      </Badge>
      {day.lateMinutes > 0 && (
        <Badge tone="warning">
          {t('attendance.summary.late')} <span className="ms-1 font-mono tabular-nums">{formatMinutes(day.lateMinutes)}</span>
        </Badge>
      )}
      {day.open && <Badge tone="info">{t('attendance.board.working')}</Badge>}
      {day.missingCheckout && <Badge tone="danger">{t('attendance.board.missingCheckout')}</Badge>}
    </span>
  );
}
